import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';
import { companyEmail, companyPhone } from '../mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0A2540] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1">
            <img
              src="https://customer-assets.emergentagent.com/job_express-delivery-98/artifacts/6aux7qgk_Logotipo%20VIBE%20LOG.png"
              alt="VIBE LOG"
              className="h-12 w-auto mb-4 brightness-0 invert" />

            <p className="text-gray-300 text-sm">
              O futuro do transporte. Logística moderna, ágil e conectada com você.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Links Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-[#F4D03F] transition-colors">
                  Início
                </Link>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('servicos')}
                  className="text-gray-300 hover:text-[#F4D03F] transition-colors">

                  Serviços
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('orcamento')}
                  className="text-gray-300 hover:text-[#F4D03F] transition-colors">

                  Orçamento
                </button>
              </li>
              <li>
                <Link to="/area-cliente" className="text-gray-300 hover:text-[#F4D03F] transition-colors">
                  Área do Cliente
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contato</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2 text-gray-300">
                <Phone size={18} />
                <span>{companyPhone}</span>
              </li>
              <li className="flex items-center space-x-2 text-gray-300">
                <Mail size={18} />
                <span>{companyEmail}</span>
              </li>
              <li className="flex items-start space-x-2 text-gray-300">
                <MapPin size={18} className="mt-1" />
                <span>São Paulo, SP - Brasil</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Siga-nos</h3>
            <div className="flex space-x-4">
              <a
                href="#"
                className="bg-[#8B3A9C] hover:bg-[#F4D03F] p-3 rounded-full transition-colors"
                aria-label="Facebook">

                <Facebook size={20} />
              </a>
              <a
                href="#"
                className="bg-[#8B3A9C] hover:bg-[#F4D03F] p-3 rounded-full transition-colors"
                aria-label="Instagram">

                <Instagram size={20} />
              </a>
              <a
                href="#"
                className="bg-[#8B3A9C] hover:bg-[#F4D03F] p-3 rounded-full transition-colors"
                aria-label="LinkedIn">

                <Linkedin size={20} />
              </a>
            </div>
            <div className="mt-6">
              <p className="text-gray-300 text-sm mb-2">Horário de Atendimento:</p>
              <p className="text-white font-semibold">Seg-Sex: 8h às 18h</p>
              <p className="!font-semibold text-white">Sáb: 8h às 14h</p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-600 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-300 text-sm">
              © {currentYear} VIBE LOG. Todos os direitos reservados.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-gray-300 hover:text-[#F4D03F] transition-colors">
                Política de Privacidade
              </a>
              <a href="#" className="text-gray-300 hover:text-[#F4D03F] transition-colors">
                Termos de Uso
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>);

};